<template>
  <div class="panel">
    <div class="panel__header">
      <div class="grid-x grid-padding-x">
        <div class="cell auto">
          <h3 class="panel__title">Sales Reps</h3>
        </div>
      </div>
    </div>

    <div class="panel__content no-padding">
      <div :class="['loading-area', loading ? 'loading' : '']">
        <div :class="['loading-area__content', loading ? 'loading' : '']">
          <div class="commissions">
            <tableList classes="no-hover" :header="tableHeader"
                       :data="tableData"
                       :loading="loading" @sort="orderBy"
                       @callback="callback"></tableList>
          </div>
        </div>
      </div>
    </div>

    <div class="panel__footer text-right">
      <button @click="addCommission">Add Commission</button>
    </div>

    <transition name="fade">
      <div class="overlay" v-if="editingCommission">
        <div class="overlay__inner">
          <div class="panel">
            <div class="panel__header">
              <h3 class="panel__title">Add Commission</h3>

              <span class="overlay__close" @click="closeCommission">
                <i class="fal fa-times"></i></span>
            </div>

            <div class="panel__content">
              <form>
                <div class="form-field">
                  <div class="grid-x grid-padding-x">
                    <div class="cell small-4">
                      <label for="commission-override">Sales Rep</label>
                    </div>

                    <div class="cell auto">
                      <div class="searchable-field">
                        <input id="vendor-override" name="vendor-override"
                               type="text"
                               placeholder="start typing to search..."
                               v-on:input='searchSalesReps($event.target.value)'>

                        <div class="searchable-field__data"
                             v-if="searchedVendors.length > 0">

                          <div :id="row.id" class="searchable-field__option"
                               v-for="(row, key) in searchedVendors" :key="key"
                               @click="addVendor(row)">
                            {{ row.name }}
                          </div>

                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="form-field">
                  <div class="grid-x grid-padding-x">
                    <div class="cell small-4">
                      <label for="commission-override">Set Percentage</label>
                    </div>

                    <div class="cell auto">
                      <input id="commission-override" class="short-input" name="commission"
                             type="text" :value="editingCommissionValue">
                    </div>
                  </div>
                </div>
              </form>
            </div>

            <div class="panel__footer text-right">
              <button class="button--alt" @click="closeCommission">Cancel</button>

              <button @click="saveCommission()">Save</button>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import client from '@/mixins/client'
import paginationUtils from '@/mixins/paginationUtils'

export default {
  name: 'ordersSalesrepSingle',
  mixins: [client, paginationUtils],
  data: function () {
    return {
      editingLineItem: null,
      editingCommission: false,
      editingCommissionValue: '',
      editingVendor: false,
      searchingVendors: false,
      searchedVendors: [],
      order: {
        name: '#0000',
        url: '#'
      },
      date: 'Mon 1, 1970 at 0:00am',
      financialLabel: '',
      financialStatus: 'Payment',
      fulfillmentLabel: '',
      fulfillmentStatus: 'Fulfillment',
      price: 0,
      action: '/orders/' + this.$route.params.id + '/sales-rep-commissions/',
      sort: 'product__title',
      tableHeader: {
        data: [
          {
            label: 'Sales Rep',
            class: 'full'
          },
          {
            label: 'Commission %',
            class: 'medium'
          },
          {
            label: 'Commission'
          }
        ]
      },
      tableData: []
    }
  },
  methods: {
    searchSalesReps (value) {
      if (value.length >= 3 && !this.searchingSalesReps) {
        this.searchingVendors = true

        this.request('get', '/salesreps/commission-totals/', {
          search: value,
          ordering: 'name'
        }).then(response => {
          let items = response.results
          this.searchedVendors = []

          for (let i = 0; i < items.length; i++) {
            this.searchedVendors.push({
              id: items[i].id,
              name: items[i].name
            })
          }
          this.searchingVendors = false
        })
      }
    },
    addCommission () {
      this.editingCommission = true
    },
    editCommission (lineItem, value) {
      this.editingCommission = true
      this.editingLineItem = lineItem
      this.editingCommissionValue = value
    },
    closeCommission () {
      this.editingCommission = false
    },
    saveCommission () {
      this.loading = true

      let commission = document.getElementById('commission-override').value

      commission = commission.replace('$', '')
      commission = commission.replace('%', '')

      if (commission === '') {
        commission = null
      }

      this.editingCommission = false

      if (this.editingLineItem.override_commission_line_item.length > 0) {
        this.request('put', '/vendors/override-commission/' + this.editingLineItem.override_commission_line_item[0].id + '/update/', {
          line_item: this.editingLineItem.id,
          commission: commission
        }).then(response => {
          this.getData()
        })
      } else {
        this.request('post', '/vendors/override-commission/create/', {
          line_item: this.editingLineItem.id,
          commission: commission
        }).then(response => {
          this.getData()
        })
      }
    },
    editVendor (id, value) {
      this.editingVendor = true
    },
    closeVendor () {
      this.editingVendor = false
    },
    buildTable () {
      this.tableData = []
      this.commissions = this.data

      for (let i = 0; i < this.commissions.length; i++) {
        let primary = '<div class="grid-x align-middle"><div class="cell shrink">' +
          '<div class="table-list__image table-list__image--rounded">'

        if (!this.isEmpty(this.commissions[i].image) && this.commissions[i].image !== undefined) {
          primary += '<div class="table-list__image__inner">'
          primary += '<img src="' + this.commissions[i].image + '">'
          primary += '</div>'
        } else {
          primary += '<div class="table-list__image__missing">' +
            '<i class="fas fa-user"></i></div>'
        }

        primary += '</div></div><div class="cell auto">' +
          '<span class="text-overflow">' + this.commissions[i].sales_rep.user.first_name + ' ' + this.commissions[i].sales_rep.user.last_name + '</span>'

        primary += '</div></div>'

        let commission = this.commissions[i].order.subtotal_price * this.commissions[i].percent / 100

        this.tableData.push({
          post: this.commissions[i].id,
          data: [
            {
              value: primary,
              class: 'full'
            },
            {
              value: this.commissions[i].percent,
              class: 'medium'
            },
            {
              value: this.formatMoney(commission),
              span: 'fill'
            }
          ]
        })
      }
    }
  },
  created () {
    this.getData()
  }
}
</script>

<style lang="scss">
@import '../../../styles/variables';
@import '../../../styles/mixins';
</style>



// WEBPACK FOOTER //
// src/pages/orders/inc/salesCommissions.vue